import axios from 'axios';
import { API_DIPENDENTI_URL } from '../config';
import moment from 'moment';


export const cedoliniList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}buste_paga`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const V2PayrollsYearsList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}v2/payrolls/years/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const V2PayrollMonthList = async (token, year) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}v2/payrolls/years/${year}/months/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const cedoliniDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}buste_paga/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setCedolinoRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}buste_paga/${id}/read`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const cuList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}cu`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const cuDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}cu/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const V2CuYearsList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}v2/cu/years/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const V2CuDetails = async (token, year) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}v2/cu/years/${year}/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setCuRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}cu/${id}/read`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const documentiList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}docs`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const documentiDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}docs/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setDocumentiRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}docs/${id}/read`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const fetchProfile = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}profile`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const acceptPrivacy = async (token) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}accept_privacy`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

// passowords

export const changePassword = async (data) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}cambia_password`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  })
  return response.data;
}


export const recuperaPassword = async (data) => {
  const body = data;

  const response = await axios.post(`${API_DIPENDENTI_URL}recupera_password`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  return response.data;
}

export const updatePassword = async (token, data) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}update_password`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const getBalances = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/balances/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const getTipiGiustificativi = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/justifications/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const getRichiesteGiustificativi = async (token, query) => {
  // add query params like page, page_size, status
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/justification-requests/`, {
    params: {
      page: query.page || 1,
      page_size: query.page_size || 50,
      status: query.status,
      start_date: query.start_date,
      end_date: query.end_date,
    },
    headers: {
      'Authorization': `${token}`,
    }
  });
  return response.data;
};

export const createRichiestaGiustificativo = async (token, data) => {

  //   "datetime_from": "2024-06-19T20:08:48.475Z",
  // "datetime_to": "2024-06-19T20:08:48.475Z",
  //   "note": "string",
  //     "justification": 0
  let body = {
    datetime_from: data.datetime_from, // FIXME: check the timezone and fix it
    datetime_to: data.datetime_to, // FIXME: check the timezone and fix it
    note: data.note,
    justification: data.justification
  }

  const response = await axios.post(`${API_DIPENDENTI_URL}presenze/justification-requests/`, data, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const getShifts = async (token, query) => {

  // formate date in the query like yyyy-mm-dd
  let enddate = new Date(query.end);
  let startdate = new Date(query.start);
  query.end = enddate.toISOString().split('T')[0];
  query.start = startdate.toISOString().split('T')[0];


  // add query params like page, page_size, status
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/shifts/`, {
    params: {
      end_date: query.end,
      start_date: query.start,
    },
    headers: {
      'Authorization': `${token}`,
    }
  }
  )
  return response.data;
}


export const getAlerts = async (token, query, category) => {
  // add query params like page, page_size, status
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/alerts/`, {
    params: {
      is_read: query.is_read,
      ...(query.page ? {page: query.page} : {}), ...(query.page_size ? {page_size: query.page_size} : {}),
      category: category,     
    },
    headers: {
      'Authorization': `${token}`,
    }
  }
  )
  return response.data;
}

export const getAlertDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/alerts/${id}/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setAlertRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}presenze/alerts/${id}/set-as-read/`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setAllAlertsRead = async (token, category) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}presenze/alerts/set-all-as-read/`, {}, {
    headers: {
      'Authorization': `${token}`,
    },
    params: category ? { category } : {},
  })
  return response.data;
}

export const createRichiestaRimborsoSpese = async (token, data, type = 'regular') => {
  const endpoint = type === 'mileage' ? 'v2/mileage-refunds/' : 'cost-refunds/';
  const response = await axios.post(`${API_DIPENDENTI_URL}${endpoint}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      'Authorization': `${token}`,
    }
  });
  return response.data;
};


export const storicoRichiesteRimborsoSpese = async (token, page, status, type = 'regular', pageSize = 10, month, year) => {
  const endpoint = type === 'mileage' ? 'v2/mileage-refunds/' : 'cost-refunds/';
  const response = await axios.get(`${API_DIPENDENTI_URL}${endpoint}`, {
    headers: {
      'Authorization': `${token}`,
    },
    params: {
      page,
      page_size: pageSize,
      status,
      month,
      year
    }
  });
  return response.data;
};


export const deleteRichiestaRimborsoSpese = async (token, id, type = 'regular') => {
  const endpoint = type === 'mileage' ? 'mileage-refunds/' : 'cost-refunds/';
  const response = await axios.delete(`${API_DIPENDENTI_URL}${endpoint}${id}/`, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  return response.data;
};

export const patchRichiestaRimborsoInviata = async (token, id, data, type = 'regular') => {
  const endpoint = type === 'mileage' ? 'v2/mileage-refunds/' : 'cost-refunds/';
  const url = `${API_DIPENDENTI_URL}${endpoint}${id}/`;

  // 1) Se arriva già una FormData, usala così com’è
  if (typeof FormData !== 'undefined' && data instanceof FormData) {
    const response = await axios.patch(url, data, {
      headers: {
        'Authorization': `${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // 2) Altrimenti costruisci tu la FormData solo coi campi presenti in `data`
  const formData = new FormData();

  // comuni
  if (Object.prototype.hasOwnProperty.call(data, 'title'))        formData.append('title', data.title ?? '');
  if (Object.prototype.hasOwnProperty.call(data, 'description'))  formData.append('description', data.description ?? '');
  if (Object.prototype.hasOwnProperty.call(data, 'date'))         formData.append('date', data.date ?? '');

  // regular-only
  if (type !== 'mileage' && Object.prototype.hasOwnProperty.call(data, 'amount')) {
    formData.append('amount', data.amount);
  }

  // mileage-only (coerente con serializer corrente: usa PK veicolo)
  if (type === 'mileage') {
    if (Object.prototype.hasOwnProperty.call(data, 'departure_location'))
      formData.append('departure_location', data.departure_location ?? '');
    if (Object.prototype.hasOwnProperty.call(data, 'arrival_location'))
      formData.append('arrival_location', data.arrival_location ?? '');
    if (Object.prototype.hasOwnProperty.call(data, 'distance_km'))
      formData.append('distance_km', data.distance_km ?? '');
    if (Object.prototype.hasOwnProperty.call(data, 'vehicle'))
      formData.append('vehicle', data.vehicle ?? ''); // PK
  }

  // file: sostituzione/rimozione
  // - Se vuoi sostituire, passa { file: File } → diventa file_binary
  // - Se vuoi rimuovere, passa { file_binary: '' } (stringa vuota), come gestito dalla tua view
  if (Object.prototype.hasOwnProperty.call(data, 'file')) {
    formData.append('file_binary', data.file); // File o Blob
  } else if (Object.prototype.hasOwnProperty.call(data, 'file_binary')) {
    formData.append('file_binary', data.file_binary); // es. '' per rimuovere
  }

  const response = await axios.patch(url, formData, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getTimbrature = async (token, query) => {

  let enddate = new Date(query.end);
  let startdate = new Date(query.start);
  query.end = enddate.toISOString().split('T')[0];
  query.start = startdate.toISOString().split('T')[0];
  
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/inouts/`, {
    params: {
      to_date: query.end,
      from_date: query.start,
      page: query.page || 1,
      page_size: query.page_size || 100,
    },
    headers: {
      'Authorization': `${token}`,
    }
  }
  )
  return response.data;
}



export const getEmployeeSettings = async (token) => {
    const response = await axios.get(`${API_DIPENDENTI_URL}presenze/settings/`,
    {
        headers: {
          'Authorization': `${token}`,
        },
    });
    return response;
};

export const updateEmployeeSettings = async (token, settings) => {
    const response = await axios.patch(`${API_DIPENDENTI_URL}presenze/settings/`, settings, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};



export const vehiclesList = async (token, { page = 1, pageSize = 10, employee } = {}) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}vehicles/`, {
    headers: {
      'Authorization': `${token}`,
    },
    params: {
      page,
      page_size: pageSize,
      ...(employee ? { employee } : {}),
    },
  });
  return response.data;
};


export const vehicleCreate = async (token, data) => {
  const formData = new FormData();
  if (data.license_plate != null) formData.append('license_plate', data.license_plate);
  if (data.vehicle_brand != null) formData.append('vehicle_brand', data.vehicle_brand);
  if (data.vehicle_type != null) formData.append('vehicle_type', data.vehicle_type);
  if (data.vehicle_motor != null) formData.append('vehicle_motor', data.vehicle_motor);
  if (data.rate_per_km != null) formData.append('rate_per_km', data.rate_per_km);
  if (data.registration_document instanceof File || data.registration_document instanceof Blob) {
    formData.append('registration_document', data.registration_document);
  }

  const response = await axios.post(`${API_DIPENDENTI_URL}vehicles/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `${token}`,
    },
  });
  return response.data;
};


export const vehiclePatch = async (token, id, data) => {
  const formData = new FormData();
  if (data.license_plate !== undefined) formData.append('license_plate', data.license_plate);
  if (data.vehicle_brand !== undefined) formData.append('vehicle_brand', data.vehicle_brand);
  if (data.vehicle_type !== undefined) formData.append('vehicle_type', data.vehicle_type);
  if (data.vehicle_motor !== undefined) formData.append('vehicle_motor', data.vehicle_motor);
  if (data.rate_per_km !== undefined) formData.append('rate_per_km', data.rate_per_km);
  if (data.registration_document instanceof File || data.registration_document instanceof Blob) {
    formData.append('registration_document', data.registration_document);
  }
  
  const response = await axios.patch(`${API_DIPENDENTI_URL}vehicles/${id}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

export const vehicleDelete = async (token, id) => {
  const response = await axios.delete(`${API_DIPENDENTI_URL}vehicles/${id}/`, {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

// "Il mio team": contesto (abilitazione, scope, unità organizzative filtrabili)
export const getTeamContext = async (token, config = {}) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/team/`, {
    ...config,
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

// "Il mio team": calendario paginato dei colleghi visibili
// params: { start_date, end_date, ou?, search?, page?, page_size? }
export const getTeamCalendar = async (token, params, config = {}) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/team/calendar/`, {
    ...config,
    params,
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};




export const employeeSignedDocumentsList = async (
  token,
  { status = 'all', page = 1, page_size = 10 } = {},
  signal
) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}signed-documents/`, {
    params: {
      status,
      page,
      page_size,
    },
    headers: {
      'Authorization': `${token}`,
    },
    signal,
  });

  return response.data;
};


export const employeeSignedDocumentDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}signed-documents/${id}/`, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  return response.data;
};

export const employeeSignedDocumentsStats = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}signed-documents/stats/`, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  return response.data;
};
